export enum StorageBatterySystem {
  CONTAINERISED = 'CONTAINERISED',
  BUILDING = 'BUILDING',
}
export const storageBatterySystemToLabel = {
  [StorageBatterySystem.CONTAINERISED]: 'Containerised',
  [StorageBatterySystem.BUILDING]: 'Building',
};
